import options from './app.component';

/**
 * App component settings for further initialization
 */
export default {
    selector: 'dtApp',
    options
};
